import { localStorageHelper } from "@offstreetparking/design-system/utils";

const STORAGE_KEY = "portal_remembered_info";

export type RememberedInfo = {
	email?: string;
	phoneNumber?: string;
	vehicles?: { plate: string; state: string }[];
};

export const getRememberedInfo = (): RememberedInfo | null => {
	return localStorageHelper.getItem(STORAGE_KEY, null);
};

export const setRememberedInfo = (info: RememberedInfo): void => {
	localStorageHelper.setItem(STORAGE_KEY, info);
};

export const clearRememberedInfo = (): void => {
	localStorageHelper.removeItem(STORAGE_KEY);
};
